import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../../utils';
import { getSetOffDetails, createSetOffBatch } from '../../../graphql';
import type {
  GetSetOffDetailsQueryVariables,
  GetSetOffDetailsQuery,
CreateSetOffBatchMutationVariables,
  CreateSetOffBatchMutation,
} from '../../../graphql';

type SetOffDetails = NonNullable<GetSetOffDetailsQuery['getSetOffDetails']>;

export const setOffApi = createApi({
  reducerPath: 'setOffApi',
  baseQuery: baseQuery,
  tagTypes: ['setOffDetails'],
  keepUnusedDataFor: 60, // 1 minute cache
  endpoints: (builder) => ({
    getSetOffDetails: builder.query<SetOffDetails, GetSetOffDetailsQueryVariables>({
      query: (variables) => ({ body: getSetOffDetails, variables }),
      keepUnusedDataFor: 60, // 1 minute cache
      providesTags: (result, error, arg) => [{ type: 'setOffDetails', id: `${arg.invoiceid}-${arg.transactiontype}` }],
      transformResponse: (response: GetSetOffDetailsQuery) => {
        return response.getSetOffDetails || [];
      },
    }),
    createSetOffDetails: builder.mutation<CreateSetOffBatchMutation, CreateSetOffBatchMutationVariables>({
      query: (variables) => ({ body: createSetOffBatch, variables }),
      invalidatesTags: (result, error, arg) => [
        { type: 'setOffDetails', id: `${arg.targetinvoiceid}-${arg.targettransactiontype}` },
      ],
    }),
  }),
});

export const { useLazyGetSetOffDetailsQuery, useGetSetOffDetailsQuery, usePrefetch,useCreateSetOffDetailsMutation } = setOffApi;
